import {environment} from '../../../environments/environment';

export interface HouseRule {
  id: number;
  type: string;
  title: string;
  text: string;
  lang: string;
  orden: number;
  video: string | null;
  picture: string | null;
  apartment_id: number;
  created_at: string;
  updated_at: string;
}

export interface HouseRulesData {
  es: HouseRule[];
  en: HouseRule[];
  fr: HouseRule[];
  [key: string]: HouseRule[];
}

export interface HouseRules {
  data: HouseRulesData;
}

function getHouseRulesByLanguage(houseRules: HouseRules, lang: string): HouseRule[] {
  const data = houseRules.data;
  const rulesByLang = data[lang as keyof HouseRulesData] ||
    data[environment.defaultAppLang as keyof HouseRulesData] || [];
  return rulesByLang.sort((a: HouseRule, b: HouseRule) => (a.orden || 0) - (b.orden || 0));
}


export function getHouseRules(houseRules: HouseRules): HouseRule[] {
  return getHouseRulesByLanguage(houseRules, environment.defaultAppLang);
}
